//  material-ui imports
import { Menu, MenuItem, Divider, ListItemIcon } from '@mui/material';

// material-ui icons
import { Check } from '@mui/icons-material';

// ==============================|| FILEMNGR RENDER SORT BY MENU ||============================== //

const fileMngrRenderSortByMenu = (items, sortBy, sortType, setSortBy, setSortType, handleClose, sortByMenyAnchorEl, SORT_TYPE) => (
    <Menu
        id="sort-by-menu"
        anchorEl={sortByMenyAnchorEl}
        open={Boolean(sortByMenyAnchorEl)}
        onClose={handleClose}
        PaperProps={{
            style: {
                width: 200
            }
        }}
    >
        {items.map((item, index) => {
            if (item.value === 'separator') {
                return <Divider key={index} />;
            }
            return (
                <MenuItem
                    key={index}
                    onClick={() => {
                        if (item.value === SORT_TYPE?.ASC || item.value === SORT_TYPE?.DESC) {
                            setSortType(item.value);
                        } else {
                            setSortBy(item.value);
                        }
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        <Check
                            htmlColor={
                                (item.isSortType === false && item.value === sortBy) ||
                                (item.isSortType === true && item.value === sortType)
                                    ? 'rgba(0, 0, 0, 0.87)'
                                    : 'transparent'
                            }
                        />
                    </ListItemIcon>
                    {item.name}
                </MenuItem>
            );
        })}
    </Menu>
);

export default fileMngrRenderSortByMenu;
